import { twMerge } from 'tailwind-merge';

export const BASE_SIDEBAR_ITEM_STYLES = twMerge(
  'flex gap-2 rounded-md text-quaternary-400 items-center p-2.5 h-11 motion-reduce-transition-none',
  'hover:bg-primary-hover *:hover:text-secondary-hover [&:hover>svg]:text-quaternary-hover',
  'group-data-[expanded=true]/sidebar:px-3 group-data-[expanded=true]/sidebar:py-2 group-data-[expanded=false]/sidebar:size-10',
  'group-data-[expanded=false]/sidebar:motion-safe:[transition:padding_500ms_ease,width_500ms_ease,height_500ms_ease,background-color_200ms_ease]',
);
